export default {
  name: 'mLanguageSelect',

  data() {
    return {}
  },

  methods: {
    select(e) {
      this.$store.commit('locale', e.target.getAttribute('value'));
      this.$i18n.locale = e.target.getAttribute('value');
    }
  }
};
